import { logoutUser } from "apis/user/auth";
import { useAuthStore } from "store/authStore";

// 보안 관련 유틸리티
export const securityUtils = {
  // 토큰 유효성 검사
  isTokenValid: (token: string): boolean => {
    if (!token) return false;

    try {
      // JWT 토큰 구조 확인 (header.payload.signature)
      const parts = token.split(".");
      if (parts.length !== 3) return false;

      // payload 디코딩하여 만료시간 확인
      const payload = JSON.parse(atob(parts[1]));
      const currentTime = Math.floor(Date.now() / 1000);

      return payload.exp && payload.exp > currentTime;
    } catch {
      return false;
    }
  },

  // 토큰에서 사용자 정보 추출
  getUserFromToken: (token: string): any => {
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return {
        userId: payload.userId,
        email: payload.email,
        exp: payload.exp,
      };
    } catch {
      return null;
    }
  },

  // 안전한 로그아웃
  secureLogout: (): void => {
    const accessToken = useAuthStore.getState().accessToken;
    if (accessToken) {
      logoutUser(accessToken);
    }

    // 모든 저장소 정리
    localStorage.clear();
    sessionStorage.clear();

    // 쿠키 정리
    document.cookie.split(";").forEach((c) => {
      const eqPos = c.indexOf("=");
      const name = eqPos > -1 ? c.substr(0, eqPos) : c;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    });
    
    // audion_RT 쿠키 명시적 삭제
    document.cookie = "audionRT=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
    document.cookie = "refreshToken=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/"; // 기존 것도 정리

    // 페이지 새로고침으로 메모리 정리
    // window.location.href = "/";
  },

  // 개발환경에서만 토큰 정보 로깅
  logTokenInfo: (token: string): void => {
    if (process.env.NODE_ENV === "development" && token) {
      const userInfo = securityUtils.getUserFromToken(token);
    }
  },

  // 클라이언트 사이드 비밀번호 해싱 (bcrypt 대신 사용할 수 있는 대안)
  hashPassword: async (password: string): Promise<string> => {
    const encoder = new TextEncoder();
    const data = encoder.encode(
      password + import.meta.env.VITE_SALT || "default_salt"
    );
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
  },

  // 안전한 로그인 후 리다이렉트 (네트워크 기록 제거)
  secureRedirectAfterLogin: (): void => {
    // 1. 세션 스토리지에 로그인 성공 플래그 저장
    sessionStorage.setItem("loginSuccess", "true");

    // 2. 현재 페이지를 히스토리에서 제거하고 리다이렉트
    window.history.replaceState(null, "", "/");
    window.location.reload();
  },

  // 민감한 데이터를 포함한 객체에서 안전한 로깅용 객체 생성
  createSafeLogObject: (
    obj: any,
    sensitiveKeys: string[] = [
      "password",
      "token",
      "accessToken",
      "refreshToken",
    ]
  ): any => {
    const safeObj = { ...obj };
    sensitiveKeys.forEach((key) => {
      if (safeObj[key]) {
        if (typeof safeObj[key] === "string") {
          safeObj[key] = safeObj[key].length > 0 ? "***" : "";
        } else {
          safeObj[key] = "[HIDDEN]";
        }
      }
    });
    return safeObj;
  },
};
